import { Maybe } from "../../types";
import { ReportType } from "../api/biClient.types";
import { chartRelatedReportTypes } from "./chartRelatedReport.types";

export const isTabularReportType = (reportType: Maybe<ReportType>) => {
  if (!reportType) {
    throw new Error("Report type not initialized");
  }
  return reportType === ReportType.Tabular;
};

export const isTileReportType = (reportType: Maybe<ReportType>) => {
  if (!reportType) {
    throw new Error("Report type not initialized");
  }
  return reportType === ReportType.Tile;
};

export const isChartReportType = (reportType: Maybe<ReportType>) => {
  if (!reportType) {
    throw new Error("Report type not initialized");
  }
  return chartRelatedReportTypes.includes(reportType);
};

export const isPivotReportType = (reportType: Maybe<ReportType>) => {
  if (!reportType) {
    throw new Error("Report type not initialized");
  }
  return reportType === ReportType.Pivot;
};
